import React, { FC } from 'react';
import styles from './styles.module.css';
import { Button } from '@clearcover/atlas';

type SaveDiscardModalProps = {
  onDiscard: () => void;
  onSave: () => void;
  saveSubmitting?: boolean;
  discardSubmitting?: boolean;
  itemDisplay: string;
};

export const SaveDiscardModal: FC<SaveDiscardModalProps> = ({
  onSave,
  onDiscard,
  itemDisplay,
  saveSubmitting = false,
  discardSubmitting = false,
}) => {
  return (
    <div
      data-testid="save-discard-modal-container"
      className={styles.container}
    >
      <div className={styles.header}>Save your changes?</div>
      <p className={styles.message}>
        You currently have unsaved changes
        {itemDisplay !== '' && ' for '}
        <b className="fs-mask">{itemDisplay}</b>. Would you like to save your
        changes before proceeding or discard them?
      </p>
      <div className={styles.buttonContainer}>
        <Button
          block
          variant="danger-secondary"
          data-testid="save-discard-modal-discard-button"
          size="md"
          disabled={saveSubmitting}
          isSubmitting={discardSubmitting}
          onClick={onDiscard}
        >
          Discard Changes
        </Button>
        <Button
          block
          data-testid="save-discard-modal-save-changes-button"
          variant="primary"
          size="md"
          disabled={discardSubmitting}
          isSubmitting={saveSubmitting}
          onClick={onSave}
        >
          Save Changes
        </Button>
      </div>
    </div>
  );
};
